import { lazy } from 'react';

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const CardManagementViewChunk = lazy(() =>
  import('../feature-sets/CardManagementView').then(
    ({ CardManagementView }) => ({
      default: CardManagementView,
    })
  )
)

export const CardManagementPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.cardManagementPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.cardManagementPageTitle),
        },
      ]}
    >
      <CardManagementViewChunk />
    </Page>
  )
}
